export enum PolicyTypeEnum {
  ComprehensivePolicyType = 0,
  SuperSimplePolicyType = 1,
}
